import React from 'react';
import BillingReportsSection from '../../../sections/AdminDashboard/Finance/FinanceReports';

const BillingReports = () => {
  return <BillingReportsSection />;
};

export default BillingReports;
